export const Main: React.FC = ({ children }) => (
    <main className="my-2 md-3">{children}</main>
);
